import styled from 'styled-components'
import { CameraAlt, CheckCircle } from "@material-ui/icons";
import Elipse from 'images/elipse.svg';
import {ClickableIcon} from "components/Buttons/ClickableIcon/ClickableIcon.styles";
import { pageContainerStyles } from '../../../themes/layout';

export const Page = styled.div`
  height: 100%;
  background-color: white;
`

export const HiddenInput = styled.input`
  display: none;
`

export const CameraIcon = styled(CameraAlt)`
    height: 4rem !important;
    width: 4rem !important;
    fill: #FB7672 !important;
    display: flex;
    align-self: center;
`

export const CheckedCircleIcon = styled(CheckCircle)`
    width: 2rem;
    height: 2rem;
    fill: #4CAF50 !important;
    display: flex;
    align-self: center;
`

export const EliplseIcon = styled(ClickableIcon).attrs({
    src: Elipse,
})`
    width: 2rem;
    height: 2rem;
`

export const Container = styled.div`
  ${pageContainerStyles}
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--primary-contrast);
  height: 100%;
  
  .bodySignUp {
    width: 100%;
    max-width: 100%;
  }
  
  .contentBlock {
    width: 100%;
    max-width: 100%;
  }
    
    .bottomText {
        color: var(--text-secondary, rgba(0, 0, 0, 0.60));
        text-align: center;
        font-feature-settings: 'clig' off, 'liga' off;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        letter-spacing: 0.15px;
        margin-top: 1.5rem !important;
    }
    
    .errorBox {
        border-color: var(--error-main, #F44336) !important;
        color: var(--error-main, #F44336) !important;
        
        .header {
            color: var(--error-main, #F44336) !important;
        }
        .description {
            color: var(--error-main, #F44336) !important;
        }
        
        .roundedBoxDescription {
            color: var(--error-main, #F44336) !important;
        }
    }

    .roundedBox {
        border: 1px solid rgba(0, 0, 0, 0.23);
        padding: var(--boundvariablesdata);
        font-size: var(--typography-h5-size);
        border-radius: var(--borderradius);
        gap: var(--boundvariablesdata5);
        display: flex;
        flex-direction: column;
        cursor: pointer;
        
        .roundedBoxDescription {
            color: var(--text-secondary, rgba(0, 0, 0, 0.60));
            font-feature-settings: 'clig' off, 'liga' off;
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 166%;
            letter-spacing: 0.4px;
        }

        .roundedBoxContent {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }
    
    .photoBox {
        display: flex;
        align-self: center;
        flex-direction: column !important;
        
        .nameBox {
            margin-top: 0.5rem;
            color: var(--text-primary, rgba(0, 0, 0, 0.87));
            text-align: center;
            font-feature-settings: 'clig' off, 'liga' off;
            font-size: 1.5rem;
            font-style: normal;
            font-weight: 600;
            line-height: 133.4%;
        }
    }

    .contentBlock {
        margin-top: 0;
      .inset {
        margin: 0 0 1rem;
        font-size:13px;
      }
      
      .inputBox {
        display: flex;
        flex-direction: row;

        .styledInput {
          width: 100%;
        }
      }
      
      .inputBlock {
        margin: 0 !important;
      }

      .bigButtonInNewStyle {
        max-width: 24rem;
        width: 100%;
        align-self: center;
        margin: 0 auto 2rem !important;
        display: flex;
        
        .arrowIconFwdWhite {
          height: 1.5rem;
          padding-left: 0.5rem;
        }
      }
    }
  
  .halfWidth {
    max-width: 50%;
  }
  
  .licenseBox {
    max-width: 60%;
  }
  
  .profile-photo {
    color: var(--labels-primary);
  }

  .optional,
  .profile-photo {
    width: 100%;
    text-align: center;
    letter-spacing: 0.17px;
    line-height: 143%;
  }

  .optional {
    color: var(--text-secondary, rgba(0, 0, 0, 0.60));
    font-size: var(0.75rem);
    letter-spacing: 0.4px;
    line-height: 166%;
  }
  
  .photoImg {
      width: 100%;
      height: 100%;
      object-fit: cover;
  }

  .profile-photo-parent {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      font-size: var(--typography-body2-size);
      border-radius: 50%;
      border: 2px dashed rgba(0, 0, 0, 0.12);
      box-sizing: border-box;
      width: 8rem;
      height: 8rem;
      justify-content: center;
      gap: 0.63rem;
      align-self: center;
      overflow: auto;
  }

  .profile-photo-parent:hover {
    opacity: 0.2;
  }
  
  .resumeInput {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      color: var(--labels-primary);
      font-size: var(--typography-h5-size);
      background-color: var(--orange-50);
      align-items: center;
      padding: var(--boundvariablesdata);
      gap: var(--boundvariablesdata);
      border-radius: var(--borderRadius, 8px);
      border: 1px dashed var(--secondary-main, #0B4598);
      background: var(--orange-50, #FFF2DE);
      overflow-wrap: anywhere;
      width: 100%;
  }
  .candidates-who-do,
  .upload-resum {
    text-align: center;
  }
  .upload-resum {
    line-height: 133.4%;
    font-weight: 600;
  }
  .candidates-who-do {
    flex: 1;
    font-size: var(--typography-body2-size);
    letter-spacing: 0.17px;
    line-height: 143%;
  }
  .cloud-upload-outline-icon {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    overflow: hidden;
    flex-shrink: 0;
  }

    .labelContainer {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        margin: unset;
        &__leftHanded {
          align-items: center;
        }
        &.languageLabelContainer {
          align-items: center; /* vertically center for language checkboxes */
        }
    }

    .isLeftHandedContainer {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        .infoIcon {
          margin-left: 1rem;
          color: var(--text-secondary, rgba(0, 0, 0, 0.60));
        }
    }
`

export const ChangeRoleBlock = styled.div`
    display: flex;
    flex-direction: row;
    white-space: break-spaces;
    justify-content: center;
    padding-bottom: 1rem;
    
    a {
        text-decoration: underline;
        cursor: pointer;
    }
    
    @media only screen and (max-width: 400px) {
        flex-direction: column;
        align-items: center;
        white-space: unset;
    }
`

export const ErrorDescription = styled.div`
  color: var(--error-main, #F44336) !important;
  font-size: 0.75rem;
  margin-bottom: 1rem !important;
`
